import React from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import TicketHeader from "../../tickets/components/TicketHeader";
import NextRuleBtn from "./NextRuleBtn";
import "./Rule.css";
import { Helmet } from "react-helmet";
import UpButtonResults from "../../shared/components/UpBtn/UpButtonResults";
import "../../shared/components/UpBtn/UpButtonResults.css";

import { MOBILE_WIDTH } from "../../constants/otherConstants";
import useWindowDimensions from "../../WindowDimensions-hook/useWindowDimensions";

const Rule = (props) => {

  const { width } = useWindowDimensions();

  const year = new Date().getFullYear();
  function insertId(subItem) {
    // remove all html tags
    subItem = subItem.replace(/<\/?[^>]+(>|$)/g, "");
    if (!isNaN(subItem.substring(0, 1)) && subItem.substring(0, 1) > 0) {
      let [subItemNum] = subItem.split(" ", 1);
      if (
        subItemNum.substring(subItemNum.length - 1, subItemNum.length) === "."
      )
        subItemNum = subItemNum.substring(0, subItemNum.length - 1);
      return subItemNum;
    }
  }

  if (props.currentRule === undefined) return "Страница не найдена";
  if (props.currentRule === null) return "Loading...";

  const generateDescription = () => {
    const fiveSubitems = props.currentRule.subitems.slice(0, 5);

    const description = fiveSubitems.map((subitem) => {
      const textWithoutTags = subitem.replace(/<\/?[^>]+(>|$)/g, "");
      if (textWithoutTags.length <= 100) {
        if (textWithoutTags.endsWith(":")) {
          return textWithoutTags + " ";
        }
        return textWithoutTags.replace(/[.;,]+$/, "") + ". ";
      } else {
        const truncatedText = textWithoutTags.substring(0, 100);
        const lastSpaceIndex = truncatedText.lastIndexOf(" ");
        return truncatedText.substring(0, lastSpaceIndex) + "... ";
      }
    }).join("");

    let formattedDescription = description.replace(/\s{2,}/g, " ").trim();

    if (formattedDescription.endsWith(" .")) 
      {formattedDescription = formattedDescription.substring(0, formattedDescription.length - 2) + ".";}

      formattedDescription = formattedDescription.replace("... .", "... ");
      formattedDescription = formattedDescription.replace(" . ", " ");


    if  (formattedDescription.length < 150) {
      formattedDescription = formattedDescription + " | Правила дорожного движения РФ " + year + " | pddportal.ru";
    }
    
    return formattedDescription;
  }


  return (
    <div>
      <div className="shared-card" style={{ position: "relative" }}>
        <Helmet>
          <title>{`${props.currentRule.name}. ПДД РФ ${year}. pddportal.ru`}</title>
          <meta
            property="og:title"
            content={`${props.currentRule.name} | ПДД РФ ${year} | pddportal.ru`}
          />
          <meta
            name="description"
            content={generateDescription()}
          />
          <meta
            property="og:description"
            content={generateDescription()}
          />
          <meta property="og:image" content="/images/icons/logo192.png"></meta>
          <link rel="canonical" href={`https://pddportal.ru/${props.rulesType}/${props.ruleId}/`} />
        </Helmet>
        {width < MOBILE_WIDTH && <h2 style={{ padding: "0.5rem 0 0 0", textAlign: "center" }}> {props.currentRule.name} </h2>}
        <TicketHeader
          notToRenderTimer={true}
          currentTicketHeader={props.currentRule.name}
        />
        {props.currentRule.subitems.map((rule, index) => (
          <p
            id={insertId(rule)}
            className="rule"
            key={index}
            dangerouslySetInnerHTML={{ __html: rule }}
          ></p>
        ))}
        <NextRuleBtn
          currentRule={props.currentRule}
          rulesArray={props.rulesArray}
        />
        <UpButtonResults marginRight={"-8.5rem"} />
      </div>
      <div className="adblock-after-task">
        <div id="yandex_rtb_R-A-1691059-4"></div>
        <script>{window.yaContextCb.push(() => {
          window.Ya.Context.AdvManager.render({
            renderTo: 'yandex_rtb_R-A-1691059-4',
            blockId: 'R-A-1691059-4'
          })
        })}</script>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    rulesType: state.router.location.pathname.split("/")[1],
    ruleId: parseInt(state.router.location.pathname.split("/")[2]),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedRule: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Rule);
